import { autoinject, bindable } from 'aurelia-framework';
import { DialogController } from "aurelia-dialog";
import 'jquery';
import 'notify';
import { WebApiService } from '../../../../services/web-api-service';
import { BusyService } from '../../../../services/busy-service';
import { OnboardingRequirementDto } from '../../../../models/onboarding-requirement';

@autoinject
export class LinkExistingDocumentDialog {
    constructor(protected controller: DialogController,
        private busyService: BusyService,
        private api: WebApiService) {
    }


    public upload() {
        this.controller.ok("UPLOAD");
    }


    public selectAllReqs() {
        this.selectedRelatedRequirements = this.relatedRequirements;
    }

    public clearAllReqs() {
        this.selectedRelatedRequirements = [];
    }

    activate(params) {
        this.params = params;
        this.relatedRequirements = params.relatedRequirements;
        this.selectedRelatedRequirements = params.selectedRelatedRequirements;
        this.loadDataAsync();
    }

    public docs = [];
    public relatedRequirements = [];
    public selectedRelatedRequirements: any[] = [];

    public params: { carrierIntId: number, carrierId: string, req: OnboardingRequirementDto };

    private async loadDataAsync() {
        this.loadApplicableDocuments();
    }

    loadApplicableDocuments() {
        this.busyService.on();
        var params = { carrierId: this.params.carrierId, documentTypeIds: this.params.req.documentTypeIds, carrierRequirementId: this.params.req.carrierMasterApprovalRequirementId };
        return this.api.get("Carriers", "GetApplicableOnboardingRequirementDocuments", params)
            .then((result) => {
                this.docs = JSON.parse(result.response);
            })
            .finally(() => {
                this.busyService.off();
            });
    }

    public link(doc) {
        this.busyService.on();

        const requirementIdsToLink = this.selectedRelatedRequirements.map(o => o.carrierMasterApprovalRequirementId);
        //also add the primary requirement
        requirementIdsToLink.push(this.params.req.carrierMasterApprovalRequirementId);

        var params = {
            DocumentVersionId: doc.documentVersionId,
            CarrierMasterApprovalRequirementIds: requirementIdsToLink
        };
        return this.api.post("Carriers", "LinkOnboardingRequirementDocumentMultiple", params)
            .then((result) => {
                this.controller.ok(true);
            })
            .finally(() => {
                this.busyService.off();
            });
    }

    public unlink(doc) {
        this.busyService.on();

        const requirementIdsToUnlink = this.selectedRelatedRequirements.map(o => o.carrierMasterApprovalRequirementId);
        //also add the primary requirement
        requirementIdsToUnlink.push(this.params.req.carrierMasterApprovalRequirementId);

        var params = {
            DocumentVersionId: doc.documentVersionId,
            CarrierMasterApprovalRequirementIds: requirementIdsToUnlink
        }
        return this.api.post("Carriers", "UnlinkOnboardingRequirementDocument", params)
            .then((result) => {
                this.controller.ok(true);
            })
            .finally(() => {
                this.busyService.off();
            });
    }
}